import auth from 'services/authentication/reducer';
import modal from 'services/modals/reducer';
import operation from 'app/operations/reducer';
import encoder from 'services/encoder/reducer';
import error from 'app/errors/reducer';
import upload from 'services/file-upload/reducer';
import { reactReduxViewReducer } from 'lib/react-redux-view';
import reduxReactorResource from 'lib/redux-reactor-resource';

const scheduledReducers = {};

export function scheduleReducer(name, reducer) {
  scheduledReducers[name] = reducer;
}

export function getScheduledReducers() {
  return scheduledReducers;
}

export default {
  auth,
  modal,
  views: reactReduxViewReducer,
  resources: reduxReactorResource.reducer,
  operation,
  error,
  upload,
  jobs: encoder,
};
